import * as c from "react";
import f from "../../../rc-util/es/raf.mjs";
const m = function() {
  var e = c.useRef(null);
  function n() {
    f.cancel(e.current);
  }
  function r(t) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    n();
    var a = f(function() {
      u <= 1 ? t({
        isCanceled: function() {
          return a !== e.current;
        }
      }) : r(t, u - 1);
    });
    e.current = a;
  }
  return c.useEffect(function() {
    return function() {
      n();
    };
  }, []), [r, n];
};
export {
  m as default
};
//# sourceMappingURL=useNextFrame.mjs.map
